import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class LoadingService {
  loadingRequests: any[] = [];
  fileLoading: boolean = false;
  loadingProgress: number = 0;
  playGame: boolean = false;

  // if request is incoming we push it in array of loading requests
  pushLoadingRequests(request: any) {
    this.loadingRequests.push(request);
  }

  // if any request is done we pop it from the array
  // we don't care which request we pop (we pop last one), final number is only important, how many pushed and how many popped
  popLoadingRequests() {
    this.loadingRequests.pop();
  }
}
